import { Link, T } from 'govwell-ui'

import { routes } from '@redwoodjs/router'
import { CellSuccessProps } from '@redwoodjs/web'

import { RecordTypeStatusDisplay } from '../RecordTypeStatus/RecordTypeStatusDisplay'

export const QUERY = gql`
  query RecordLinkCellQuery($id: Int!) {
    recordById(id: $id) {
      uuid
      isDraft
      status {
        id
        type
        name
      }
      id
      stringified
    }
  }
`

interface Props extends CellSuccessProps {
  text: string
}

export const Loading = (props: Props) => (
  <T.Body>
    <Link externalHref="">{props.text}</Link>
  </T.Body>
)

export const Success = (props: Props) => {
  const {
    recordById: { uuid, status, isDraft, stringified },
  } = props
  return (
    <T.Body>
      <Link internalRoute={routes.record({ recordUuid: uuid })}>
        {stringified} {status && <RecordTypeStatusDisplay status={status} isDraft={isDraft} />}
      </Link>
    </T.Body>
  )
}
